/**
 * Created by linli on 1/21/2016.
 */

'use strict';

angular.module('betosyswebapp')

  .service('updaterService', function ($q, $http, localStorageService, $window, version) {

    this.doUpdate = function () {
      var versionInLocalStorage = localStorageService.get('version');
      if (!versionInLocalStorage || versionInLocalStorage !== version) {
        localStorageService.set('version', version);
      }
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/common/services/updaterService.js